const HTML_ESCAPE_CHARACTERS: Readonly<Record<string, string>> = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
};

function escapeHtml(value: string): string {
	return value.replace(/[&<>"']/g, (character) => HTML_ESCAPE_CHARACTERS[character] ?? character);
}

/**
 * Formats a plain-text description (as returned by the LLM executor) into the HTML
 * paragraph shape the SAP editor expects.
 */
export function formatDescriptionForSapEditor(description: string): string {
	const normalizedDescription = description.replace(/\r\n/g, '\n').trim();

	if (normalizedDescription.length === 0) return '';

	return normalizedDescription
		.split(/\n\s*\n+/)
		.map((paragraph) => `<p>${escapeHtml(paragraph.trim()).replace(/\n/g, '<br />')}</p>`)
		.join('<p>&nbsp;</p>');
}
